import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'getImcGrade'
})
export class GetImcGradePipe implements PipeTransform {

  transform(value: number): { name: string; color: string; } {
    let classification: { name: string; color: string; } = {name: 'Desconocido', color: 'black'};
    if (value < 18.5) {
      classification = {name: 'Peso bajo', color: '#ed576b'};
    } else if (value >= 18.5 && value < 25) {
      classification = {name: 'Peso normal', color: '#2196F3'};
    } else if (value >= 25 && value < 30) {
      classification = {name: 'Sobrepeso', color: '#EFB68A'};
    } else if (value >= 30 && value < 35) {
      classification = {name: 'Obesidad clase I', color: '#ed576b'};
    } else if (value >= 35 && value < 40) {
      classification = {name: 'Obesidad clase II', color: '#eb445a'};
    } else if (value >= 40) {
      classification = {name: 'Obesidad clase III', color: '#fe2642'};
    }
    return classification;
  }

}
